import type { ReactNode } from 'react';

type InputWithClearProps = {
  value: string;
  onClear: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
};

/** Wraps an input/textarea with a one-click clear control when non-empty. */
export function InputWithClear({
  value,
  onClear,
  children,
  className = '',
  disabled = false,
}: InputWithClearProps) {
  const showClear = !disabled && value.trim().length > 0;
  return (
    <div className={`input-with-clear${className ? ` ${className}` : ''}`}>
      {children}
      {showClear ? (
        <button
          type="button"
          className="input-with-clear__btn"
          aria-label="Clear"
          title="Clear"
          onClick={onClear}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
